module.exports = __webpack_public_path__ + "static/maxrec-fb-a5378c6677cdda75bee2a5655f5f06af.png";